(() => {
  if (!window.CSS || !window.CSS.supports('-webkit-overflow-scrolling: touch')) {
    return;
  }

  const scrollElements = [
    document.scrollingElement || document.documentElement,
    document.documentElement,
    'body',
  ];
  const isInputInPositionFixedParent = (input) => {
    const positionFixedParents = window.swinger.$('*')
      .filter((elem) => scrollElements.indexOf(elem) === -1)
      .filter((elem) => elem.contains(input))
      .filter((elem) => window.getComputedStyle(elem).getPropertyValue('position') === 'fixed');

    return positionFixedParents.length > 0;
  };
  const keyboardInputsSelector = [
    'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"])',
    'textarea',
    '[contenteditable]',
  ].join(',');
  const scrollPositions = window.WeakMap ? new WeakMap() : new Map();
  let scrollLockDebounceTimer;
  let scrollLockActive = false;
  let scrollLock;
  const adjustScrollPositions = () => {
    if (!scrollLockActive) {
      return;
    }
    scrollElements.forEach((elem) => {
      const scrollElement = typeof elem === 'string' ? document.querySelector(elem) : elem;
      scrollElement.scrollTop = scrollPositions.get(scrollElement) || 0;
    });
    scrollLock = window.requestAnimationFrame(adjustScrollPositions);
  };
  const startLock = () => {
    scrollLockActive = true;
    scrollElements.forEach((elem) => {
      const scrollElement = typeof elem === 'string' ? document.querySelector(elem) : elem;
      scrollPositions.set(scrollElement, scrollElement.scrollTop);
      scrollElement.style.scrollBehavior = 'auto';
      scrollElement.style.position = 'fixed';
    });
    scrollLock = window.requestAnimationFrame(adjustScrollPositions);
  };
  const stopLock = () => {
    scrollLockActive = false;
    window.cancelAnimationFrame(scrollLock);
    scrollElements.forEach((elem) => {
      const scrollElement = typeof elem === 'string' ? document.querySelector(elem) : elem;
      scrollElement.style.scrollBehavior = '';
      scrollElement.style.position = '';
    });
  };

  document.addEventListener('focus', (e) => {
    const target = window.swinger.eventHub.getTarget(e);

    if (
      !target.matches(keyboardInputsSelector)
      || !isInputInPositionFixedParent(target)
    ) {
      window.clearTimeout(scrollLockDebounceTimer);
      stopLock();
      return;
    }

    window.clearTimeout(scrollLockDebounceTimer);
    scrollLockDebounceTimer = window.setTimeout(startLock);
  }, true);

  document.addEventListener('blur', (e) => {
    const target = window.swinger.eventHub.getTarget(e);

    if (
      !target.matches(keyboardInputsSelector)
      || !isInputInPositionFixedParent(target)
    ) {
      window.clearTimeout(scrollLockDebounceTimer);
      stopLock();
      return;
    }

    window.clearTimeout(scrollLockDebounceTimer);
    scrollLockDebounceTimer = window.setTimeout(stopLock, 200);
  }, true);

  if (!window.visualViewport) {
    return;
  }

  window.visualViewport.addEventListener('resize', () => {
    const focusedElement = document.activeElement;

    if (!focusedElement.matches(keyboardInputsSelector)) {
      return;
    }

    if (!focusedElement.scrollIntoViewIfNeeded) {
      return;
    }

    window.setTimeout(() => {
      focusedElement.scrollIntoViewIfNeeded(false);
    }, 50);
  });
})();
